import React, { useRef, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import IntroductionTabs from '../../IntroductionTabs';
import BusinessDepartmentShowcase from './BusinessDepartmentShowcase';
import './businessfield.css';

const Business = () => {
  const infraRef = useRef(null);
  const [chainInView, setChainInView] = useState(false);

  useEffect(() => {
    const el = infraRef.current;
    if (!el) return;
    if (typeof window !== 'undefined' && !('IntersectionObserver' in window)) {
      setChainInView(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setChainInView(true);
          io.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  const canonical = 'https://www.xn--o39ap7bo6pk0bo2x.com/business';
  const title = '쿠팡 사업부 - 주식회사 가까운물류';
  const desc = '쿠팡 물류 시스템과의 연동을 통한 효율적인 배송 서비스를 제공합니다.';

  const cards = [
    {
      title: '쿠팡 물류 시스템 연동',
      description: '실시간 데이터 기반의\n효율적인 배송 운영',
      descVariant: 'preline',
    },
    {
      title: 'CLS·퀙플렉스 벤더 운영',
      description: '전문 물류 벤더사와의\n협업을 통한 안정적 운영',
      descVariant: 'preline',
    },
    {
      title: 'CPA 정책위원 활동',
      description: '업계 정책 참여 및 파트너사 협력 강화',
      descVariant: 'tight',
    },
    {
      title: '배송기사 관리·안전교육',
      description: '체계적인 인력 관리\n정기적 안전 교육 제공',
      descVariant: 'preline',
    },
  ];

  return (
    <div className="business-page">
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonical} />
        <meta name="description" content={desc} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="주식회사 가까운물류" />
        <meta property="og:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
      </Helmet>

      <IntroductionTabs type="business">
        <div tabId="coupang" className="business-content">
          <BusinessDepartmentShowcase
            headline={
              <>
                <span className="hl">쿠팡사업부</span>는 쿠팡 물류 시스템과의 연동을<br />기반으로 
                
                신속하고 효율적인 배송 서비스를 제공합니다.
              </>
            }
            pill="대형 물류 플랫폼의 기준"
            pillDescription="운영 역량과 실시간 시스템 연동을 통해 안정적인 라스트마일 배송을 구현합니다."
            featureTitle="쿠팡사업부의 특성"
            featureEmphasis="쿠팡사업부는 단순 사업부가 아니라, 물류 시스템과 정책 참여까지 아우르는 종합 물류 운영 조직입니다."
            featureDescription="기술 기반의 운영 역량과 현장 중심의 관리 체계를 통해 안정적이고, 이를 위해 벤더·시스템·인력·정책을 집중 운영합니다."
            centerLabel="쿠팡 사업부"
            cards={cards}
            layout="cardsRow"
          />

          {/* 운영 인프라 및 지사 구성 */}
          <section className="deptv2-infra" ref={infraRef}>
            <div className="deptv2-infra-inner deptv2-infra--vertical">
              <h3 className="deptv2-infra-title deptv2-infra-title--center">
                <span className="hl">주식회사 가까운물류</span>의 운영 인프라 및 지사 구성
              </h3>
              <p className="deptv2-infra-sub deptv2-infra-sub--center">
                본사를 중심으로 아래와 같은 단위 지사 조직을 운영하고 있습니다.
              </p>

              <div className={`deptv2-infra-chain ${chainInView ? 'is-in-view' : ''}`} aria-label="지사 구성 다이어그램">
                <div className="deptv2-chain-node deptv2-chain-node--core">본사</div>
                <div className="deptv2-chain-node deptv2-chain-node--branch">서울 지사</div>
                <div className="deptv2-chain-node deptv2-chain-node--branch deptv2-chain-node--daegu">대구 지사</div>
                <div className="deptv2-chain-node deptv2-chain-node--branch">부산 지사</div>
              </div>

              <div className="deptv2-infra-copy">
                <p className="deptv2-infra-copy-title">
                  <span className="hl">조직 구조를 기반으로</span>
                </p>
                <p className="deptv2-infra-copy-desc">
                  지역별 물류 특성에 맞춘 운영과 빠른 대응이 가능하며,
                  <br />
                  <span className="hl">고객과 파트너사 모두에게</span> 안정적인 서비스를 제공합니다.
                </p>
              </div>
            </div>
          </section>
        </div>
      </IntroductionTabs>
    </div>
  );
};

export default Business;
